import I18n from 'i18n-js';

import {
  Listing,
  core_apimessages_Listing_ListingType,
} from './rql';

import { IUser } from './components/user_context_provider';
import experiments from './experiments';
import { isExperimentEnabled } from './user_context_helpers';

function offersEnabled(listing: Listing) {
  return listing.listingType === core_apimessages_Listing_ListingType.MAKE_AN_OFFER;
}

export function getWatchNudgeText(user: Partial<IUser>, listing: Listing) {
  if (!user.loggedOut || offersEnabled(listing)) return;
  return I18n.t('commons.nudgeManager.watchNudge');
}

export function getOfferNudgeText(user: Partial<IUser>, userTotalOffersCount: number) {
  const inOpenToOffersLoggedInExp = !user.loggedOut
    && isExperimentEnabled(user, experiments.OPEN_TO_OFFERS_LOGGED_IN)
    && userTotalOffersCount === 0;

  if (user.loggedOut || inOpenToOffersLoggedInExp) {
    return I18n.t('commons.nudgeManager.negotiate');
  }
}
